import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Card, CardContent, CardMedia, Chip, Container, Grid, Stack, Typography } from '@mui/material';
import Page from './Page';
import Header from './Header';
import { useCatalog } from './contexts/CatalogContext.jsx';
import { getPrimaryImageUrl } from './utils/productImage';

const formatPrice = (cents = 0, currency = 'USD') => {
  const value = (cents || 0) / 100;
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency
  });
  return formatter.format(value);
};

const ProductsPage = () => {
  const { products = [], catalog, loading } = useCatalog();

  return (
    <Page>
      <Container maxWidth="lg">
        <Header text="Rental Catalog" subHeader={catalog ? catalog.description : 'Choose a table cloth and we will ship it directly to you.'} />
        {loading && (
          <Typography variant="body1" sx={{ mb: 4 }}>
            Loading products…
          </Typography>
        )}
        {!loading && products.length === 0 && (
          <Typography variant="body1" sx={{ mb: 4 }}>
            No products are available right now. Check back soon!
          </Typography>
        )}
        <Grid container spacing={4} sx={{ mt: 1 }}>
          {products.map(product => {
            const imageUrl = getPrimaryImageUrl(product);

            return (
              <Grid key={product.slug} item xs={12} sm={6} md={4}>
                <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', borderRadius: 3, boxShadow: '0 18px 40px rgba(0,0,0,0.08)' }}>
                  <CardMedia
                    component="img"
                  image={imageUrl}
                  alt={product.name}
                  sx={{ height: 220, objectFit: 'cover' }}
                />
                <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                  <Stack spacing={1} sx={{ flexGrow: 1 }}>
                    <div>
                      <Typography variant="overline" sx={{ letterSpacing: '0.2em', color: 'text.secondary' }}>
                        Casino Cloth
                      </Typography>
                      <Typography variant="h5" sx={{ fontWeight: 600 }}>
                        {product.name}
                      </Typography>
                    </div>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                      {product.description?.slice(0, 120) || 'Premium felt with bold artwork for high-impact tables.'}
                    </Typography>
                    <Chip
                      label={`${formatPrice(product.price_cents, product.currency)} base rental`}
                      color="primary"
                      sx={{ alignSelf: 'flex-start' }}
                    />
                  </Stack>
                  <Button
                    component={RouterLink}
                    to={`/products/${product.slug}`}
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{ mt: 3, borderRadius: 999 }}
                  >
                    Add to Cart
                  </Button>
                </CardContent>
              </Card>
            </Grid>
            );
          })}
        </Grid>
      </Container>
    </Page>
  );
};

export default ProductsPage;
